import React from 'react';
import useTranslate from '@src/i18n/useTranslate';

import { ForeignAlertContainer, ForeignAlertBadge, ForeignAlertTitle, ForeignAlertDescription } from './styles';

const ForeignAlert = () => {
  const { i18n, i18nElement } = useTranslate();

  return (
    <ForeignAlertContainer>
      <ForeignAlertBadge>{i18n('checkout_foreign_buyer_alert_badge')}</ForeignAlertBadge>

      <ForeignAlertTitle>{i18n('checkout_foreign_buyer_alert_title')}</ForeignAlertTitle>

      <ForeignAlertDescription>{i18nElement('checkout_foreign_buyer_alert_description')}</ForeignAlertDescription>
    </ForeignAlertContainer>
  );
};

export default ForeignAlert;
